import React, { useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import {
  useAppEventGameDetailSelector,
  useAppEventLeaderBoardSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { CRYPTO_SECRET_KEY, removeTrailingZero, URLS } from "src/_config";
const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoGameLeaderBoardPage() {
  const eventApi = useEventApi();
  const leaderBoardSelector = useAppEventLeaderBoardSelector();
  const history = useHistory();
  const { eventId, gameId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const g_id: number = parseInt(cryptr.decrypt(gameId));
  const eventGameDetailsSelector = useAppEventGameDetailSelector();

  const goBack = (e: any) => {
    e && e.preventDefault();
    history.push(`/event/${eventId}/${gameId}`);
  };

  const callViewLeaderBoard = () => {
    const params = {
      rodeo_event_id: e_id,
      event_id: g_id,
    };
    eventApi.callViewLeaderBoard(
      params,
      (message: string, resp: any) => {
        if (resp) {
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    callViewLeaderBoard();
  }, []);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <Link to="#" onClick={(e) => goBack(e)} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </Link>
        Results
      </h2>
      <div className="score-range-wrap">
        <div className="score-box d-flex justify-content-between">
          <h4 className="d-inline-block title-player">Riders</h4>
          <div className="gua-sc">Vote Received(%)</div>
        </div>
        <ul className="cons-list">
          {leaderBoardSelector && leaderBoardSelector.riders && leaderBoardSelector.riders.length ? (
            leaderBoardSelector.riders.map((rider: any) => (
              <li key={rider.id}>
                <span className="name-img">
                  <em className="user-img-wrap">
                    <img
                      src={rider && rider.rider && rider.rider.original ? rider.rider.original : "/images/no-image.png"}
                      alt={rider.name}
                    />
                  </em>
                  {rider.name}
                </span>
                <span className="count-vote">
                  {
                    // removeTrailingZero(rider.vote)
                    eventGameDetailsSelector.events && eventGameDetailsSelector.events.ispicked
                      ? removeTrailingZero(rider.vote)
                      : "-"
                  }
                </span>
              </li>
            ))
          ) : (
            <li className="no-rider">No record found!</li>
          )}
        </ul>
      </div>
    </React.Fragment>
  );
}
